<template>
  <div v-show="isShow" class="qrcode" @click="close">
    <div>
      <div class="qrcode__title">请用手机扫描二维码打开</div>
      <div id="qrcode" class="qrcode__code"></div>
    </div>
  </div>
</template>
<script>
/* import VueQr from 'vue-qr'; 该插件兼容性差 */
import QRCode from 'QRCode';
import qrLogo from 'assets/img/qr_logo.png';

export default {
  props: ['isShow', 'url'],
  data() {
    return {
      qrLogo,
      defaultImgIndx: 0,
    };
  },
  created() {
    this.drawQrcode();
  },
  methods: {
    drawQrcode() {
      const { url, qrLogo } = this;
      const t = setInterval(() => {
        const dom = document.getElementById('qrcode');
        if (dom) {
          const Qrcode = new QRCode(dom, {
            titleHeight: 0,
            width: 200,
            height: 200,
            logo: qrLogo,
            logoWidth: 40,
            logoHeight: 40,
          });
          try {
            Qrcode.makeCode(url);
            clearInterval(t);
          } catch (error) {
            clearInterval(t);
          }
        }
      }, 500);
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.qrcode {
  width: 500px; /*no*/
  position: fixed;
  top: 0;
  left: calc(50% - 250px); /*no*/
  right: calc(50% - 250px); /*no*/
  bottom: 0;
  z-index: 5000;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;

  &__title {
    color: #fff;
    font-size: 28px;
    text-align: center;
    margin: 20px 0;
  }

  &__code {
    background: #fff;
    padding: 20px;
  }
}
</style>
